import React from "react";
import { Row, Col, Button, Form, InputGroup, FormControl, ButtonGroup, ToggleButton } from 'react-bootstrap';
import Modal from 'react-modal';
import { useSingleQuote } from "../../hook/useSingleQuote"
import SelectSearch from 'react-select-search';
import api from '../../api'
import { toast } from "react-toastify";
import style from './index.module.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(style);

interface ModelProps {
    isOpen: boolean;
    sessionId: string | null;
    mtype: string;
    handleClose: () => void;
    symCnName: string;
    handleSymCnName: (name: string) => void;
    sym: string;
    handleSym: (sym: string) => void;
    buyOrSell: "B" | "S" | null;
    handleBuyOrSell: (bs: "B" | "S" | null) => void;
    orderPriceType: "1" | "2" | null;
    handleOrderPriceType: (type: "1" | "2" | null) => void;
    orderTime: "R" | "I" | "F" | null;
    handleOrderTime: (tif: "R" | "I" | "F" | null) => void;
    price: number;
    handleOrderPrice: (price: number) => void;
    qty: number;
    handleOrderQty: (qty: number) => void;
    handleOrderPlace: () => void;
    //母股漲停跌停價格
    target_upprice: number | null;
    target_downprice: number | null;
    target_money: string
}
const sideRadios = [
    { name: '買進', value: 'B' },
    { name: '賣出', value: 'S' },
];
const orderPriceTypeRadios = [
    { name: '限價單', value: '2' },
    { name: '市價單', value: '1' },
];
const orderTimeRadios = [
    { name: 'ROD', value: 'R' },
    { name: 'IOC', value: 'I' },
    { name: 'FOK', value: 'F' },
];


function useRegisterData(symbol: string, sessionId: string | null) {
    React.useEffect(() => {
        (async function () {
            if (sessionId === null) { return }
            (window.parent as any).vm.scrollTo();
            await api.registerTick({
                symbols: symbol,
                types: ['Tick', 'BA', "BNS"],
                masterSessionId: sessionId
            });
        })();
    }, [symbol, sessionId]);
}
const OrderModel: React.FC<ModelProps> = ({
    isOpen,
    sessionId,
    mtype,
    handleClose,
    symCnName,
    handleSymCnName,
    sym,
    handleSym,
    buyOrSell,
    handleBuyOrSell,
    orderPriceType,
    handleOrderPriceType,
    orderTime,
    handleOrderTime,
    price,
    handleOrderPrice,
    qty,
    handleOrderQty,
    handleOrderPlace,
    /**母股漲停 */
    target_upprice,
    /**母股跌停 */
    target_downprice,
    /**母股現價 */
    target_money
}) => {
    const currentSymbol = sym ? sym + `.TW${mtype}` : ""
    const asyncState = useSingleQuote({ symbol: currentSymbol, sessionId: sessionId || "" });
    /**權證跌停  quote有 */
    const downPrice = asyncState.value?.HighLimitPrice
    /**權證漲停  quote有 */
    const upPrice = asyncState.value?.LowLimitPrice
    /**權證現價   quote有 **/
    const wrrantPrice = asyncState.value?.Price
    /**母股現價 api 拿～ ws有的話在拿*/
    const targetPrice = asyncState.value?.target_money ? asyncState.value?.target_money : target_money

    // React.useEffect(() => { console.log("母股漲停", target_upprice, "母股跌停", target_downprice, "權證跌停", downPrice, "權證漲停", upPrice, "權證現價", wrrantPrice, "母股現價", targetPrice) }, [target_upprice, target_downprice, downPrice, upPrice, wrrantPrice, targetPrice])

    const handleOnFiveOrder = (buyOrSell: "B" | "S", price: number) => {
        // handleBuyOrSell(buyOrSell)
        handleOrderPrice(price)
    }

    const handleOnchange = (e: any,) => {
        handleSym(e)
        handleSymCnName(e)
    }
    useRegisterData(currentSymbol, sessionId)

    const handlePriceType = (e: "1" | "2") => {
        handleOrderPriceType(e)
        if (e === "1") {
            toast.info('市價買賣權證容易買到漲停賣到跌停，建議用限價單。', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }

    const OrderPlace = () => {
        // 檢查委買價是否少於 0.1
        if ( buyOrSell === "B" && price <= 0.1) {
        toast.info("委託失敗，請留意低單價權證之交易風險，如短天期之時間價值耗損較高或太價外之價格敏感度較低等風險。", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
        return; // 停止執行 OrderPlace
    }
        ///(1).若操作的權證【現價=漲停價】，且使用者用【市價】【買進】或(2).若操作的權證【現價=跌停價】，且使用者用【市價】【賣出】時
        if (upPrice && wrrantPrice && orderPriceType === "1" && (Number(wrrantPrice) >= Number(upPrice) && buyOrSell === "B")) {
            toast.info('市價買賣權證容易買到漲停賣到跌停，建議用限價單。', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
        if (downPrice && wrrantPrice && orderPriceType === "1" && (Number(wrrantPrice) <= Number(downPrice) && buyOrSell === "S")) {
            toast.info('市價買賣權證容易買到漲停賣到跌停，建議用限價單。', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
        ////【標的母股】的【現價=漲停價】，且使用者要【買進】
        if (target_upprice && targetPrice && (Number(targetPrice) >= Number(target_upprice) && buyOrSell === "B")) {
            toast.info('提醒您!標的股票漲停時，券商無法買進股票避險，所以不會掛賣單，較容易買到其他投資人掛的不合理價格。', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }

        ///【標的母股】的【現價=跌停價】，且使用者要【賣出】
        if (target_downprice && targetPrice && (Number(targetPrice) <= Number(target_downprice) && buyOrSell === "S")) {
            toast.info('提醒您!標的股票跌停時，券商無法賣出股票避險，所以不會掛買單，較容易賣到其他投資人掛的不合理價格。', {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }

        handleOrderPlace()
    }
    const searchInput = React.useMemo(() => {
        if (sym === "") {
            return <SelectSearch
                className="select-search-one select-search-order"
                options={[]}
                search
                emptyMessage="找不到標的"
                placeholder="請輸入關鍵字"
                value={sym}
                onChange={(e) => handleOnchange(e)}
            />
        }
        return <SelectSearch
            className="select-search-one select-search-order"
            options={[]}
            debounce={800}
            getOptions={(query) => {
                return new Promise((resolve, reject) => {
                    fetch(`${process.env.REACT_APP_URL}api2/Trade/Warrants`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            sym: query || symCnName || sym,
                            row: 100,
                            page: 0
                        })
                    })
                        .then((response) => response.json())
                        .then((e) => {
                            const data = e.warrants
                            resolve(
                                data.map(searchWarrantFormatter)
                            );
                        })
                        .catch(reject);
                });
            }}
            search
            emptyMessage="找不到標的"
            placeholder="請輸入關鍵字"
            value={sym}
            onChange={(e) => handleOnchange(e)}
        />
    }, [symCnName, symCnName, sym]);

    return (
        <Modal
            isOpen={isOpen}
            contentLabel=""
            onRequestClose={handleClose}
            className="Modal"
            overlayClassName="Overlay"
            shouldCloseOnOverlayClick={false}
            ariaHideApp={false}
        >
            <>
                <div>
                    <div className="modalTitle">權證下單</div>
                    <div className="modalRight">
                        <button className="modalCloseButton" onClick={handleClose} >
                            <span className="modalCloseButtonFont">&times;</span>
                        </button>
                    </div>
                </div>
                <div className="modalContent">
                    <Form>
                        <Form.Group as={Row} className="mb-2">
                            <Col style={{ display: "flex", paddingRight:"0" }} xs>
                                <Form.Label column className={ cx('formlabel-18px') }>
                                    權證名稱
                                </Form.Label>
                            </Col>
                            <Col md="9" xs="8">
                                {searchInput}
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                            <Col style={{ display: "flex" , paddingRight:"0"}}>
                                <Form.Label column className={ cx('formlabel-18px')}>
                                    買賣
                                </Form.Label>
                            </Col>
                            <Col md="9" xs="8" >
                                <ButtonGroup className="w-100">
                                    {sideRadios.map((radio, idx) => (
                                        <ToggleButton
                                            key={idx}
                                            id={`sideRadio-${idx}`}
                                            type="radio"
                                            variant={radio.value === null ? "" : radio.value === "S" ? 'outline-success' : 'outline-danger'}
                                            name="sideRadio"
                                            value={radio.value}
                                            checked={buyOrSell === radio.value}
                                            onChange={() => handleBuyOrSell(radio.value as "B" | "S")}
                                            style={{fontSize:"18px"}}
                                        >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                            <Col style={{ display: "flex" , paddingRight:"0"}}>
                                <Form.Label column className={ cx('formlabel-18px')}>
                                    交易別
                                </Form.Label>
                            </Col>
                            <Col md="9" xs="8" >
                                <ButtonGroup className="w-100">
                                    {orderPriceTypeRadios.map((radio, idx) => (
                                        <ToggleButton
                                            key={idx}
                                            id={`priceType-${idx}`}
                                            type="radio"
                                            variant={"outline-light"}
                                            name="priceTypeRadio"
                                            value={radio.value}
                                            checked={orderPriceType === radio.value}
                                            onChange={() => { handlePriceType(radio.value as "1" | "2") }}
                                            style={{fontSize:"18px"}}
                                        >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                            <Col style={{ display: "flex", paddingRight:"0" }}>
                                <Form.Label column className={ cx('formlabel-18px')}>
                                    掛單類別
                                </Form.Label>
                            </Col>
                            <Col md="9" xs="8" >
                                <ButtonGroup className="w-100">
                                    {orderTimeRadios.map((radio, idx) => (
                                        <ToggleButton
                                            key={idx}
                                            id={`orderTime-${idx}`}
                                            type="radio"
                                            variant={"outline-light"}
                                            name="orderTimeRadio"
                                            value={radio.value}
                                            checked={orderTime === radio.value}
                                            onChange={() => { handleOrderTime(radio.value as "R" | "I" | "F") }}
                                            style={{fontSize:"18px"}}
                                        >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                            <Col style={{ display: "flex" , paddingRight:"0"}}>
                                <Form.Label column className={ cx('formlabel-18px')}>
                                    委託價格
                                </Form.Label>
                            </Col>
                            <Col md="9" xs="8">
                                {orderPriceType === "1" ? <InputGroup.Text>市價</InputGroup.Text> : <InputGroup>
                                    <FormControl
                                        type="number"
                                        step="0.01"
                                        value={price}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleOrderPrice(Number(e.target.value)) }}
                                    />
                                    <InputGroup.Text>元</InputGroup.Text>
                                </InputGroup>}

                            </Col>

                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                            <Col style={{ display: "flex" , paddingRight:"0"}}>
                                <Form.Label column className={ cx('formlabel-18px')}>
                                    張數
                                </Form.Label>
                            </Col>
                            <Col md="9" xs="8">
                                <InputGroup >
                                    <FormControl
                                        type="number"
                                        value={qty}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            const re = /^[0-9\b]+$/;
                                            if (e.target.value === '' || re.test(e.target.value)) {
                                                handleOrderQty(Number(e.target.value))
                                            }
                                        }}
                                    />
                                    <InputGroup.Text>張</InputGroup.Text>
                                </InputGroup>
                            </Col>
                        </Form.Group>
                    </Form>
                    <div className='button-group '>
                        <Col style={{ display: "inline-grid" }}>
                            <Button className="order-button-cancel" size="lg" onClick={handleClose} >取消</Button>
                        </Col>
                        <Col style={{ display: "inline-grid" }}>
                            <Button className="order-button" size="lg" onClick={OrderPlace}>確認</Button>
                        </Col>
                    </div>
                </div>
                <div className='modalFoot'>
                    <Row>
                        <Col>
                            <h5 className="text-danger text-center">委買價/量</h5>
                            <div>
                                {asyncState.value?.Bids.map((item, index) => {
                                    if (index >= 5) { return }
                                    return (<InputGroup className="five-group" key={"B" + index + item.Price + Math.random()} onClick={() => { handleOnFiveOrder("S", item.Price) }}>
                                        <InputGroup.Text bsPrefix="fiveBuy">買</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            value={item.Price}
                                            disabled
                                            readOnly
                                            className="fivePrice"
                                        />
                                        <Form.Control
                                            type="number"
                                            value={item.Volume}
                                            disabled
                                            readOnly
                                            className="fiveQuantity"
                                            style={{ border: "0px"}}
                                        />
                                    </InputGroup>)
                                })}

                            </div>

                        </Col>
                        <Col>
                            <h5 className="text-success text-center">委賣價/量</h5>
                            {asyncState.value?.Asks.map((item, index) => {
                                if (index >= 5) { return }
                                return (<InputGroup className="five-group" key={"S" + index + item.Price + Math.random()} onClick={() => { handleOnFiveOrder("B", item.Price) }}>
                                    <InputGroup.Text bsPrefix="fiveSell">賣</InputGroup.Text>
                                    <Form.Control
                                        type="number"
                                        value={item.Price}
                                        disabled
                                        readOnly
                                        className="fivePrice"
                                    />
                                    <Form.Control
                                        type="number"
                                        value={item.Volume}
                                        disabled
                                        readOnly
                                        className="fiveQuantity"
                                        style={{ border: "0px"}}
                                    />
                                </InputGroup>)
                            })}
                        </Col>
                    </Row>
                </div>
            </>
        </Modal >

    );
}
function searchWarrantFormatter(data: any) {
    return {
        value: data.id,
        name: data.name,
    };
}
export default OrderModel;